<template>
  <div>
    <v-date-picker
      ref="date_picker"
      v-model="period_sync"
      :active-picker.sync="activePicker"
      :allowed-dates="with_allowed_dates ? $_allowedDates : () => true"
      class="elevation-0 calendar date_picker main__light_green"
      :class="className + ' ' + (activePicker.toLowerCase() + '-calendar')"
      color="var(--v-secondary__green_not_active-base)"
      :disabled="disabled"
      first-day-of-week="1"
      :locale="$i18n.locale"
      :max="maxDate"
      :min="minDate"
      no-title
      :picker-date.sync="month"
      :range="range"
      scrollable
      width="306"
      @change="changeDate"
      @click:date="chooseDate"
      @update:active-picker="changedActPicker"/>
  </div>
</template>
<script>
import moment from 'moment'
import { datePickerMixin } from 'mixins'

export default {
  name: 'datePicker',
  mixins: [ datePickerMixin ],
  data() {
    return {
      activePicker: '',
      month: '',
    }
  },
  props: {
    disabled: [ Boolean, String ],
    period: [Array, String],
    className: String,
    range: Boolean,
    range_part: {
      type: Number,
      validator(value) {
        return [null, 0, 1].includes(value)
      },
      default: null,
    },
    with_allowed_dates: Boolean,
    'min-date': String,
    'max-date': String,
    fixed_value: String,
  },
  mounted() {
    this.updMonth()
  },
  computed: {
    period_sync: {
      get() {
        this.customizeSelected()
        if ( this.range ) {
          this.updMonth(true)
          return this.period.length > 1 && this.period.every(el => el) ? this.period : this.period[this.range_part]
        }

        return this.period
      },
      set(value) {
        if ( !this.disabled ) {
          if ( this.range ) {
            let dateRange = []
            if (this.range_part === 0) {
              dateRange = [value[1] || value[0], this.period[1]]
            } else if ( this.range_part && this.period?.length ) {
              const dateFrom = this.period.length === 2 ? this.period[0] : null
              const dateTo = value[1] || value[0]
              dateRange = [dateFrom, dateTo]
            } else {
              dateRange = value.sort()
            }
            this.$emit('update:period', dateRange)
          } else {
            this.$emit('update:period', value)
          }
        } else  if ( this.disabled == 'start' ) {
          this.$emit('update:period', [this.period[0], value[1] || value[0] ] )
        }
      }
    },
  },
  methods: {
    updMonth(check) {
      let date = this.range ? this.period[this.range_part] : this.period,
        min_date = date && date > this.minDate ? date : this.minDate,
        month = moment( min_date || undefined ).format('YYYY-MM')

      this.month = check && !date ? this.month : month
    },
    changedActPicker(type) {
      if ( type == 'MONTH') {
        this.$_customizeMonths()
      } if ( type == 'DATE') {
        this.customizeCalendar()
      }
    },
    chooseDate(date) {
      this.$emit('chooseDate', date)
    },
    changeDate(date) {
      this.$emit('changeDate', date)
    },
    customizeCalendar() {
      this.customizeCalendarDays()
      this.customizeSelected()
    },
    customizeCalendarDays() {
      this.$nextTick(() => {
        let table = this.$el,
          tds = table.querySelectorAll('td ')

        this.$_.forEach( tds, td => {
          let text = td.textContent,
            className = this.month + '-' + ( text ? text < 10 ? '0' + text : text : 'empty'),
            btn = td.firstChild
          if ( td.classList.length ) {
            td.classList.remove( td.classList[0] )
          }

          td.classList.add( className )
          if (!btn) { return }
          if ( this.fixed_value &&  moment( this.fixed_value).format('YYYY-MM-DD') == className ) {
            btn?.classList.add('v-btn--outlined')
            td.setAttribute('title', this.$t('Tenders.PlannedFromApp'))
          }
          let date_type = this.$_allowedDates(className, true)
          btn.classList.remove('HOLIDAY')
          btn.classList.remove('WORK_DAY')
          btn.classList.remove('DAY_OFF')

          btn.classList.add(date_type)

        })
      })
    },
    customizeSelected() {
      this.$nextTick(() => {
        let table = this.$el,
          tds = table.querySelectorAll('td ')

        this.$_.forEach( tds, td => {
          let text = td.textContent,
            className = this.month + '-' + ( text ? text < 10 ? '0' + text : text : 'empty'),
            btn = td.firstChild
          if (!btn) { return }
          btn.classList.remove('rounded')
          btn.classList.remove('from')
          btn.classList.remove('to')
          btn.classList.remove('active')

          if ( this.period_sync?.length) {

            if ( (this.range && (this.period.some(el => !el) || this.period[0] == this.period[1] ) )
              || className == moment( this.period_sync).format('YYYY-MM-DD')) {
              if ( !this.range
                || (this.period[ this.range_part ] && className == moment( this.period[ this.range_part ]).format('YYYY-MM-DD') )) {
                btn.classList.add('rounded')
              }
            } else {
              if ( className ==  moment( this.period_sync[0]).format('YYYY-MM-DD') ) {
                btn.classList.add('from')
              } else if ( className ==  moment( this.period_sync[1]).format('YYYY-MM-DD') ) {
                btn.classList.add('to')
              } else if ( this.range
                && moment(className) < moment(this.period_sync[1])
                && moment(className) > moment(this.period_sync[0]) ) {
                btn.classList.add('active')
              }
            }
          }
        })
      })
    }
  },
  watch: {
    month(value) {
      this.$store.dispatch('getHolidays', value).finally( () => this.customizeCalendar() )
    }
  }
}
</script>
<style lang="scss">
.calendar.date_picker {
  .v-date-picker-table--date {
    height: unset;
    .v-btn, td  {
      width: 40px;
    }
    tr, .v-btn, td  {
      height: 40px;
    }
  }
  .v-picker__body {
    background-color:  var(--v-main__light_green-base) !important ;
    .v-date-picker-table:not(.v-date-picker-table--month) {
      .v-btn {
        &.v-date-picker-table__current.WORK_DAY .v-btn__content {
          color: rgba(var(--black-color-rgba), 0.87);
        }
        &.DAY_OFF {
          &, &.v-btn--disabled {
            color: var(--color-info) !important;
          }
          &.v-btn--disabled {
            opacity: 0.3;
          }
          &.rounded, &.to, &.from {
            color: var(--v-main__light_green-base) !important;
          }
        }
        &.HOLYDAY {
          &, &.v-btn--disabled {
            color:  var(--v-secondary__red-base) !important;
          }
          &.v-btn--disabled {
            opacity: 0.3;
          }
        }
        &.fixed-value {
          border-radius: 50%;
        }
        &.rounded {
          border-radius: 50% !important;
        }
        &.rounded, &.to, &.from {
          .v-btn__content{
            border-radius: 50%;
            background-color: var(--v-main__green-base) !important;
            height: 100%;
            width: 100%;
          }
        }

        // border: none !important;
        &.v-btn--active {
          background-color: var(--v-secondary__green_chosen-base) !important;
          color: var(--black-color);
          &::before {
            opacity: 0 !important;
          }
          &.active {
            border-radius: 0 ;
          }
          &.from {
            border-radius:50%  0 0 50% ;
          }
          &.to {
            border-radius:  0 50% 50%  0 ;
          }
        }
      }
    }
  }
}

  .v-date-picker-header__value button {
    text-transform: capitalize;
  }
</style>
